// extracted by mini-css-extract-plugin
export default {"video":"vk5rs","player":"DXJe8","poster":"Zi8tl"};